import { FC } from 'react';

import { DateValidationError, PickerChangeHandlerContext } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Dayjs } from 'dayjs';

import CustomDatePicker from 'src/components/NPIDateRangePicker/CustomDatePicker';

interface NPISingleDatePickerProps {
    value: Dayjs | null;
    onChange: (value: Dayjs, context: PickerChangeHandlerContext<DateValidationError>) => void;
    minDate?: Dayjs;
    maxDate?: Dayjs;
    disableFuture?: boolean;
}

const NPISingleDatePicker: FC<NPISingleDatePickerProps> = ({
    value,
    onChange,
    minDate,
    maxDate,
    disableFuture = true,
}) => {
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <CustomDatePicker
                value={value}
                onChange={onChange}
                maxDate={maxDate}
                minDate={minDate}
                disableFuture={disableFuture}
                sx={{
                    maxWidth: '180px',
                    '.MuiInputBase-root': {
                        backgroundColor: '#f39e4e',
                        borderColor: '#f39e4e',
                        marginTop: '-8px',
                    },
                    '.MuiInputBase-input': {
                        backgroundColor: '#f39e4e',
                        color: '#fff',
                    },
                    '.MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderColor: '#f39e4e',
                        },
                        '&:hover fieldset': {
                            borderColor: '#f39e4e',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#f39e4e',
                        },
                    },
                    '.MuiSvgIcon-root': {
                        color: '#fff',
                    },
                }}
            />
        </LocalizationProvider>
    );
};

export default NPISingleDatePicker;
